const BillboardMap = () => import(/* webpackChunkName: "BillboardMap" */ '../views/BillboardMap')

const adminRouter = [
    {
      path: '/billboard-map',
      name: 'billboardmap',
      component: BillboardMap,
      meta: { isLinkAja: true }
    }
]

export default adminRouter;
